module.exports = __webpack_public_path__ + "img/sandwich-1.ad9e9c04.jpg";